import { useSelector } from 'react-redux';
import { selectAuth } from '../../redux/slices/auth';
import { Navigate, Outlet } from 'react-router-dom';
import Crm from './Crm';
import { useLocation } from 'react-router-dom';

function ProtectedRoute() {
    const auth = useSelector(selectAuth);
    const location = useLocation();
    if (!auth.user) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }
    return (
    <Crm >
        <Outlet />
    </Crm >
    );
}

export default ProtectedRoute;